import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Button from "shared/components/FormElements/Button";
import Modal from "shared/components/UIElements/Modal";
import { COMPANY_DOMAINS } from "@routebot/constants";
import "./TransportTypeSetupModal.css";

const TransportTypeSetupModal = ({ show, onSelect, isLoading }) => {
  const { t } = useTranslation();
  const [selectedType, setSelectedType] = useState("both");

  const handleConfirm = () => {
    onSelect(selectedType);
  };

  const transportTypes = [
    {
      id: COMPANY_DOMAINS.STUDENT,
      label: t("transportType.student"),
      icon: "🎒",
      description: t("transportType.studentDescription"),
    },
    {
      id: COMPANY_DOMAINS.PERSONEL,
      label: t("transportType.personel"),
      icon: "💼",
      description: t("transportType.personelDescription"),
    },
    {
      id: "both",
      label: t("transportType.both"),
      icon: "🚌",
      description: t("transportType.bothDescription"),
    },
  ];

  return (
    <Modal
      show={show}
      header={t("transportType.title")}
      onCancel={() => {}} // Prevent closing
      footerClass="transport-type-modal-footer"
      footer={
        <div className="transport-type-modal-buttons">
          <Button onClick={handleConfirm} isLoading={isLoading} disabled={isLoading}>
            {t("continue")}
          </Button>
        </div>
      }
    >
      <div className="transport-type-modal-content">
        <p className="transport-type-description" style={{ whiteSpace: "pre-wrap" }}>
          {t("transportType.description")}
        </p>

        <div className="transport-type-options">
          {transportTypes.map((type) => (
            <div
              key={type.id}
              className={`transport-type-option ${selectedType === type.id ? "selected" : ""}`}
              onClick={() => setSelectedType(type.id)}
            >
              <div className="transport-type-icon">{type.icon}</div>
              <div className="transport-type-info">
                <h3>{type.label}</h3>
                <p>{type.description}</p>
              </div>
              <div className="transport-type-radio">
                <input
                  type="radio"
                  name="transportType"
                  value={type.id}
                  checked={selectedType === type.id}
                  onChange={() => setSelectedType(type.id)}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </Modal>
  );
};

export default TransportTypeSetupModal;
